const getters = {
  
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js